import { render, staticRenderFns } from "./VaCheckbox.demo.vue?vue&type=template&id=c1274808&"
import script from "./VaCheckbox.demo.vue?vue&type=script&lang=js&"
export * from "./VaCheckbox.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports